module.exports = __webpack_public_path__ + "static/media/legal-services.149d2252.png";